/* Pufosel — header mega menu, mobile drawer, cookie preferences link.
   Plain JS, no dependencies, ~2 KB. Everything degrades to normal links. */
(function () {
  var desktop = window.matchMedia('(min-width: 990px)');
  var header = document.querySelector('[data-pf-header]');
  var mega = document.querySelector('[data-pf-mega]');
  var megaBtn = document.querySelector('[data-pf-mega-toggle]');
  var drawer = document.querySelector('[data-pf-drawer]');
  var drawerBtn = document.querySelector('[data-pf-drawer-open]');
  var lastFocus = null;

  function setMega(open) {
    if (!mega || !megaBtn) return;
    mega.hidden = !open;
    megaBtn.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('pf-mega-open', open);
  }

  function showLevel(id) {
    drawer.querySelectorAll('.pf-drawer__level').forEach(function (l) {
      var on = id ? l.id === id : l.getAttribute('data-pf-level') === 'root';
      l.hidden = !on;
    });
    var target = id ? document.getElementById(id) : drawer.querySelector('[data-pf-level="root"]');
    var f = target && target.querySelector('a, button');
    if (f) f.focus();
  }

  function setDrawer(open) {
    if (!drawer) return;
    if (open) {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.classList.add('pf-lock');
      showLevel(null);
    } else {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('pf-lock');
      setTimeout(function () { drawer.hidden = true; }, 200);
      if (lastFocus) lastFocus.focus();
    }
    if (drawerBtn) drawerBtn.setAttribute('aria-expanded', String(open));
  }

  if (megaBtn) megaBtn.addEventListener('click', function () { setMega(mega.hidden); });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pf-mega-open]');
    if (opener) {
      e.preventDefault();
      if (desktop.matches && mega) { setMega(true); window.scrollTo({ top: 0, behavior: 'smooth' }); megaBtn && megaBtn.focus(); }
      else setDrawer(true);
      return;
    }
    if (mega && !mega.hidden && !e.target.closest('[data-pf-mega]') && !e.target.closest('[data-pf-mega-toggle]')) setMega(false);
    if (e.target.closest('[data-pf-drawer-open]')) setDrawer(true);
    if (e.target.closest('[data-pf-drawer-close]')) setDrawer(false);
    var sub = e.target.closest('[data-pf-open-sub]');
    if (sub) showLevel(sub.getAttribute('data-pf-open-sub'));
    if (e.target.closest('[data-pf-back]')) showLevel(null);
    if (e.target.closest('[data-pf-cookie-prefs]')) {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      } else if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
          if (window.privacyBanner && window.privacyBanner.showPreferences) window.privacyBanner.showPreferences();
        });
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (mega && !mega.hidden) { setMega(false); megaBtn && megaBtn.focus(); }
    if (drawer && !drawer.hidden) setDrawer(false);
  });

  desktop.addEventListener('change', function () { setMega(false); if (drawer && !drawer.hidden) setDrawer(false); });

  if (header && header.classList.contains('pf-header-wrap--sticky')) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { header.classList.toggle('is-scrolled', window.scrollY > 8); ticking = false; });
    }, { passive: true });
  }
})();
